<div class="text-center">
  <img
    src="../../../../assets/media/enac-logo.png"
    alt="ENAC logo"
    class="w-30 no-select"
  />
  <mat-spinner class="mx-auto block !w-10" />
</div>
